import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import 'react-h5-audio-player/lib/styles.css';
import { TopicsContext } from '../../contexts/Topics';
import { UsersContext } from '../../contexts/Users';
import { ITEM_STATUS } from '../../models/Completion';
import Error from '../common/Error';
import CompleteNote from '../common/CompleteNote';
import EvidenceList from '../common/EvidenceList.js';
import MarkItemChecked from '../common/MarkItemChecked';
import StatusLight from '../common/StatusLight';
import SummativeComment from '../common/SummativeComment';
import MessageForm from '../messaging/MessageForm';
import * as CSS from './elements/Task.js';

const Task = observer(({ moduleId, taskId, store }) => {
  const usersStore = useContext(UsersContext);
  const topicsStore = useContext(TopicsContext);

  const loggedInUser = usersStore.getLoggedInUser();

  const module = topicsStore.getModuleById(moduleId);
  if (!module) return <Error msg="Module not found" />;

  const task = module.getItemById(taskId, 'tasks');
  if (!task) return <Error msg="Task not found" />;

  const evidence = loggedInUser.private.getEvidenceByTaskId(taskId);
  const isEvidenced = evidence[0]?.length > 0;
  const status = loggedInUser.private.getItemStatus(taskId, 'tasks');
  const completion = loggedInUser.private.getItemCompletion(taskId);
  // completed work is read only for students until a teacher reopens it
  const isComplete = status === ITEM_STATUS.complete;

  return (
    <CSS.EvidenceContainer>
      <MarkItemChecked
        student={loggedInUser}
        itemId={taskId}
        collection="tasks"
      />
      <CSS.ItemInstructions complete={status === ITEM_STATUS.complete}>
        {task.instructions}
      </CSS.ItemInstructions>
      <StatusLight status={status} itemId={taskId} />
      {status === ITEM_STATUS.complete && (
        <SummativeComment
          summary={completion.summary}
          heading="Your teacher's summary"
        />
      )}
      {isEvidenced && (
        <EvidenceList
          evidence={evidence}
          resource="task"
          taskId={taskId}
          studentId={loggedInUser.id}
          store={store}
          isLocked={isComplete}
        />
      )}
      {isComplete ? (
        <CompleteNote resource="task" />
      ) : (
        <MessageForm taskId={taskId} moduleId={moduleId} />
      )}
    </CSS.EvidenceContainer>
  );
});

export default Task;
